<template>
  <div class="empty-blocks-page"
       :class="blocksStyles">
    <div class="blocks">
      <div v-if="$mq !== 'mobile'"
           class="blocks-icon">
        <icon-block-shield :width="this.$mq === 'mobile' ? '50' : '100'"
                           :height="this.$mq === 'mobile' ? '50' : '100'"
                           iconColor="#8067b7" />
      </div>
    </div>

    {{ $t("tabs.blocksAlerts.empty") }}

    <base-button class="retry-button"
                 color="primary"
                 :loading="loading"
                 @click="$emit('retry')">
      {{ $t("tabs.tapToRetry") }}
    </base-button>
  </div>
</template>

<script>
  export default {
    props: {
      loading: {
        required: true,
        type: Boolean
      }
    },

    computed: {
      blocksStyles() {
        return {
          'empty-blocks-page-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .empty-blocks-page {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .blocks {
      text-align: center;

      &-icon {
        background: lighten(map-get($colors, primary), 40%);

        padding: 50px;
        margin-bottom: 20px;
        border-radius: 50%;

        display: flex;
        justify-content: center;
      }
    }

    .retry-button {
      margin: 12px auto;
    }
  }

  .empty-blocks-page-mobile {
    .blocks {
      &-icon {
        padding: 40px;
        margin-bottom: 10px;
      }

      .retry-button {
        margin: 10px auto;
      }
    }
  }
</style>
